import styled from 'styled-components';
import {
  Icon as SemanticIcon,
} from 'semantic-ui-react';
import { Text } from '@playbookux/playbook-web-core';

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0;
  ${(props) => (props.noBorder ? '' : 'border-top: 1px solid rgba(0,0,0,.1);')};
  :hover {
    background-color: ${(props) => props.theme.color.rowHover};
  }
`;

export const Icon = styled(SemanticIcon)``;

export const TableCardValue = styled(Text)`
  width: 50%;
  word-break: break-word;
`;

export const ContainerAccordion = styled.div`
  display: flex;
  color: #477AE9;
  cursor: pointer;
`;

export const RemainingText = styled.a``;

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

export const Image = styled.img`
  max-height: 90px;
  max-width: 150px;
`;

export const ContainerCardName = styled.div`
  width: 50%;
  display: flex;
`;

export const CardName = styled(Text)`
  font-weight: 500;
  word-break: break-word;
`;

export const ContainerCardNameImage = styled.div`
  background-color: #f3f7fe;
  padding: 5px;
  border-radius: 4px;
  margin: 10px;
  height: min-content;
`;
